import React from "react";
import { Link } from "react-router-dom";
import { Instagram, MessageSquare, Facebook, Mail } from "lucide-react";
import { BRAND, CONTACT, SOCIALS } from "@/data/site";

// TikTok isn't in lucide; use a small inline SVG.
function TikTok({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M16.5 3c.3 2.1 1.5 3.6 3.5 3.9V10c-1.3.1-2.5-.3-3.6-.9v5.7c0 3.3-2.4 5.7-5.5 5.7-3 0-5.4-2.3-5.4-5.3 0-3 2.3-5.3 5.4-5.3.3 0 .6 0 .9.1v3.1c-.3-.1-.6-.2-.9-.2-1.3 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3 2.4-1 2.4-2.6V3h2.7z" />
    </svg>
  );
}

export default function Footer() {
  const year = 2020;
  return (
    <footer className="bg-onyx border-t border-gold/20">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-12">
        {/* Logo + Follow us */}
        <div className="flex flex-col items-center gap-8 text-center sm:flex-row sm:items-center sm:justify-between sm:text-left">
          <Link to="/" aria-label={`${BRAND.name} home`}>
            <img src={BRAND.logo} alt={`${BRAND.name} logo`} width={220} height={140} className="h-16 w-auto" />
          </Link>
          <div className="flex flex-col items-center gap-3 sm:items-end">
            <span className="text-[0.7rem] font-semibold uppercase tracking-[0.24em] text-ivory/80">
              Follow Us
            </span>
            <div className="flex items-center gap-5">
              {SOCIALS.instagram && (
                <a href={SOCIALS.instagram} target="_blank" rel="noreferrer" aria-label="Instagram"
                   className="text-gold transition-all duration-300 hover:-translate-y-0.5 hover:text-gold/80">
                  <Instagram size={22} />
                </a>
              )}
              {SOCIALS.tiktok && (
                <a href={SOCIALS.tiktok} target="_blank" rel="noreferrer" aria-label="TikTok"
                   className="text-gold transition-all duration-300 hover:-translate-y-0.5 hover:text-gold/80">
                  <TikTok size={22} />
                </a>
              )}
              {SOCIALS.facebook && (
                <a href={SOCIALS.facebook} target="_blank" rel="noreferrer" aria-label="Facebook"
                   className="text-gold transition-all duration-300 hover:-translate-y-0.5 hover:text-gold/80">
                  <Facebook size={22} />
                </a>
              )}
            </div>
          </div>
        </div>

        {/* Text us bar */}
        <a
          href={CONTACT.smsHref}
          className="mt-8 flex w-full items-center justify-center gap-3 border border-gold/50 py-4 text-sm font-medium uppercase tracking-[0.2em] text-gold transition-colors hover:bg-gold hover:text-onyx"
        >
          <MessageSquare size={18} /> Text Us {CONTACT.phoneDisplay}
        </a>

        {/* Email contact */}
        <a
          href="mailto:Bg.enhanced@gmail.com"
          data-testid="footer-email"
          className="mt-3 flex items-center justify-center gap-2 text-sm text-muted-ivory transition-colors hover:text-gold"
        >
          <Mail size={16} /> Bg.enhanced@gmail.com
        </a>

        {/* Fine print */}
        <div className="mt-8 flex flex-col items-center justify-between gap-3 text-[0.7rem] text-muted-ivory sm:flex-row">
          <p>© {year} {BRAND.name}. {BRAND.city}, {BRAND.region}.</p>
          <div className="flex items-center gap-5">
            {SOCIALS.googleReview && (
              <a href={SOCIALS.googleReview} target="_blank" rel="noreferrer" className="hover:text-gold transition-colors">
                Reviews
              </a>
            )}
            <Link to="/privacy" className="hover:text-gold transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-gold transition-colors">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
